var render = function render(){var _vm=this,_c=_vm._self._c;return _c('apexchart',{attrs:{"height":"380","options":_vm.visitorBarChartConfig,"series":[{  name: 'Sales',data: _vm.CrmAnalyticsSalesSeries },{name: 'Value',data: _vm.CrmAnalyticsSalesSeries1 }]}})
}
var staticRenderFns = []

export { render, staticRenderFns }